import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "../../lib/utils"
import { DialogContext } from "./dialog"

function Popover({ ...props }) {
   return (
      <PopoverPrimitive.Root
         data-slot="popover"
         {...props}
      />
   )
}

function PopoverTrigger({ ...props }) {
   return (
      <PopoverPrimitive.Trigger
         data-slot="popover-trigger"
         {...props}
      />
   )
}

const PopoverContent = React.forwardRef(
   ({ className, align = "center", sideOffset = 4, ...props }, ref) => {
      // Do not want to render portals inside dialogs.
      // This causes scroll problems.
      // Ref: https://github.com/shadcn-ui/ui/issues/607

      const isInsideDialog = React.useContext(DialogContext)
      const shouldRenderWithoutPortal = isInsideDialog

      const content = (
         <PopoverPrimitive.Content
            ref={ref}
            align={align}
            sideOffset={sideOffset}
            className={cn(
               "z-50 w-72 rounded-(--borderRadius)! border! border-(--borderColor)! bg-(--menuBackgroundColor)! p-4! text-popover-foreground shadow-(--box-shadow) outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 box-border!",
               className
            )}
            {...props}
         />
      )

      if (shouldRenderWithoutPortal) {
         return content
      }

      return (
         <PopoverPrimitive.Portal>
            {content}
         </PopoverPrimitive.Portal>
      )
   }
)

function PopoverAnchor({ ...props }) {
   return (
      <PopoverPrimitive.Anchor
         data-slot="popover-anchor"
         {...props}
      />
   )
}

export {
   Popover,
   PopoverTrigger,
   PopoverContent,
   PopoverAnchor
}
